import React, { useEffect, useRef, useState } from "react";
import pageHeadingStyles from "../../../styles/PageHeader.module.scss";
import styles from "./styles.module.scss";
import SearchInput from "../../../components/SearchInput/SearchInput";
import ButtonIcon from "../../../components/ButtonIcon/ButtonIcon";
import useTemplateStore from "../../../stores/templates";
import PlusIcon from "../../../assets/svg/icons/common/Plus";
import { Link } from "react-router-dom";
import {
  GetAllOrganizationsSingleCall,
  GetOrganizationById,
} from "../../../../api/index";
import useUserStore from "../../../stores/user.js";
import Select from '../../../components/form/select'

const Header = () => {
  const [organizations, setOrganizations] = useState([]);
  const [users, setUsers] = useState([]);
  const isAddTemplateOpen = useTemplateStore(
    (state) => state.isAddTemplateOpen,
  );
  const setSearchFilters = useTemplateStore((state) => state.setSearchFilters);
  const searchFilters = useTemplateStore((state) => state.searchFilters);
  const selectedOrg = useTemplateStore((state) => state.selectedOrg);
  const selectedUser = useTemplateStore((state) => state.selectedUser);
  const isPCAdmin = useUserStore((state) => state.isPCAdmin);
  const setIsAddTemplateModalOpen = useTemplateStore(
    (state) => state.setIsAddTemplateModalOpen,
  );
  const timerRef = useRef(null);
  const handleChange = (e) => {
    setSearchFilters({
      ...searchFilters,
      search: e.target.value,
    });
  };
  const handleAddTemplate = () => {
    setIsAddTemplateModalOpen(true);
  };

  const handleUserChange = (selectedValues) => {
    setSearchFilters({
      ...searchFilters,
      selectedUser: selectedValues,
    });
  };
  const handleOrgChange = async (orgId) => {
    setSearchFilters({
      ...searchFilters,
      selectedOrg: orgId,
    });
    if (orgId !== "") {
      try {
        const res = await GetOrganizationById(orgId);

        let usersOptions = [];
        if (res.users && res.users.length > 0) {
          res.users.forEach((user) => {
            usersOptions.push({ label: user.name, value: user.id });
          });
        }
        setUsers(usersOptions);
      } catch (error) { }
    }
  };

  useEffect(() => {
    GetAllOrganizationsSingleCall().then((res) => {
      let orgsOptions = [];
      if (res.organization && res.organization.length) {
        orgsOptions = res.organization.map((organization) => {
          return {
            label: organization.name,
            value: organization.id,
          };
        });
        setOrganizations(orgsOptions);
      }
    });
  }, []);
  return (
    <>
      <div className={pageHeadingStyles.page_heading}>
        <div className={pageHeadingStyles.title_contents}>
          <p>Templates</p>
        </div>
        <div className={styles.right_side}>
          <SearchInput onChange={handleChange} />
          <ButtonIcon
            bgColor="#4C70EF"
            textColor="#FFF"
            onClick={handleAddTemplate}
          >
            <PlusIcon />
            <span>Add Template</span>
          </ButtonIcon>
          {/* <Link to="/v2/templates/create">
            <ButtonIcon
              bgColor="#4C70EF"
              textColor="#FFF"
            >
              <PlusIcon />
              <span>Add Template</span>
            </ButtonIcon>
          </Link> */}
        </div>
      </div>
      {isPCAdmin ? (
        <div className={pageHeadingStyles.page_heading}>
          <div className={styles.select_container}>
            <Select
              placeholder="Select Organization"
              value={searchFilters.selectedOrg}
              onChange={handleOrgChange}
              options={organizations}
            />
            <Select
              placeholder="Select User"
              value={searchFilters.selectedUser}
              onChange={handleUserChange}
              options={users}
            />
          </div>
        </div>
      ) : null}
    </>
  );
};

export default Header;
